import {
  AppBar,
  Box,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import logoVivia from "../images/logo.png";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Menu } from "@mui/icons-material";

function ResponsiveAppBar({
  scrollToHomePage,
  scrollToAboutUs,
  scrollToFeatures,
  scrollToProjects,
  scrollToBlog,
  scrollToContact,
}: any) {
  const { t, i18n } = useTranslation();

  const navItems = [t("About Us"), t("Features"), t("Projects"), t("Blog")];
  const listNav = [
    t("Homepage"),
    t("About Us"),
    t("Our features"),
    t("Our projects"),
    t("Blog"),
    t("Contact"),
  ];
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
  const handleLanguageChange = (lang: "en" | "fr") => {
    i18n.changeLanguage(lang);
  };
  const navigateToSection = (item: any) => {
    if (["About Us", "À propos de nous"].includes(item)) {
      scrollToAboutUs();
    }
    if (
      [
        "Features",
        "Fonctionnalités",
        "Our features",
        "Nos fonctionnalités",
      ].includes(item)
    ) {
      scrollToFeatures();
    }
    if (["Projects", "Projets", "Our projects", "Nos projets"].includes(item)) {
      scrollToProjects();
    }
    if (item === "Blog") {
      scrollToBlog();
    }
    if (item === "Contact") {
      scrollToContact();
    }
  };

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{
        textAlign: "center",
        color:
          " radial-gradient(39.87% 39.87% at 50% 50%, #0C3247 0%, #081525 100%)",
        backgroundColor: "#081525",
        height: "100%",
        pt: 4,
        gap: 3,
      }}
    >
      <img
        src={logoVivia}
        alt="logo"
        onClick={scrollToHomePage}
        style={{
          cursor: "pointer",
          // maxWidth: "10%",
          // height: "auto",
          marginTop: "1rem",
          marginBottom: " 1rem",
        }}
      />

      <List
        sx={{
          justifyContent: "flex-start",
          display: "flex",
          flexDirection: "column",
          ml: 5,
          gap: 2,
        }}
      >
        {listNav.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton onClick={() => navigateToSection(item)}>
              <ListItemText primary={item} sx={{ color: "#FFF" }} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        component="nav"
        elevation={0}
        color="transparent"
        sx={{
          color:
            " radial-gradient(39.87% 39.87% at 50% 50%, #0C3247 0%, #081525 100%)",
          backgroundColor: "#081525",
        }}
      >
        <Toolbar sx={{ mt: 2, ml: 2 }}>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { lg: "none" }, color: "#FFF" }}
          >
            <Menu />
          </IconButton>
          <Stack
            direction="row"
            spacing={1}
            justifyContent="center"
            flexGrow={1}
            gap={3}
          >
            <img
              src={logoVivia}
              alt="logo"
              onClick={scrollToHomePage}
              style={{
                cursor: "pointer",
              }}
            />
            {/* </Box> */}

            <Box sx={{ display: { xs: "none", lg: "initial" } }}>
              {navItems.map((item, index) => (
                <Button
                  key={index}
                  sx={{ color: "#fff", mr: 4 }}
                  onClick={() => navigateToSection(item)}
                >
                  {item}
                </Button>
              ))}
              <Button
                variant="outlined"
                sx={{ border: "1px solid #28D1B4", color: "#fff" }}
                onClick={scrollToContact}
              >
                {t("Contact Us")}
              </Button>
            </Box>
          </Stack>
          <Stack
            direction="row"
            spacing={1}
            justifyContent="flex-end"
            flexGrow={1}
          >
            <Typography
              onClick={() => handleLanguageChange("fr")}
              sx={{
                fontFamily: "Titillium Web",
                fontSize: "20px",
                cursor: "pointer",
                fontWeight: 400,
                letterSpacing: "0%",
                verticalAlign: "middle",
                textDecoration: i18n.language === "fr" ? "underline" : "none",
                color: "#FFF",
              }}
            >
              FR
            </Typography>
            <Typography
              sx={{
                fontFamily: "Titillium Web",
                fontSize: "20px",
                cursor: "pointer",
                fontWeight: 400,
                letterSpacing: "0%",
                verticalAlign: "middle",
                color: "#FFF",
              }}
            >
              /
            </Typography>
            <Typography
              onClick={() => handleLanguageChange("en")}
              sx={{
                fontFamily: "Titillium Web",
                fontSize: "20px",
                cursor: "pointer",
                fontWeight: 400,
                letterSpacing: "0%",
                verticalAlign: "middle",
                textDecoration: i18n.language === "en" ? "underline" : "none",
                color: "#FFF",
              }}
            >
              EN
            </Typography>
          </Stack>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          // container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: { xs: "100%", sm: "50%" },
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}

export default ResponsiveAppBar;
